import type { ReactNode } from 'react';

import type { Example, ExamplesBlock, ReferenceCardsBlock } from '@/types';
import { Content } from '@/ui/Content/Content';

import { ReferenceCards } from '../ReferenceCards/ReferenceCards';

import styles from './Examples.module.scss';

interface Props {
    actions?: ReactNode;
    filters?: ReactNode;
    examples: Example[];
    hasIntro: ExamplesBlock['has_intro'];
    intro: ExamplesBlock['intro'];
    isHero?: boolean;
}

export function BlockContent({ actions, filters, examples, hasIntro, intro, isHero }: Props) {
    const cards = examples.map<ReferenceCardsBlock['cards'][number]>((example) => ({
        id: String(example.id),
        hideReadMoreLabel: false,
        card: { ...example, contentType: 'examples' },
    }));

    return (
        <div className={styles.examples}>
            {hasIntro && intro && (
                <Content
                    className={styles.intro}
                    classes={{ inner: styles.introInner }}
                    isHero={isHero}
                    has_byline
                    title={intro.title ?? ''}
                    byline={intro.byline}
                    body={intro.body}
                    customActions={filters}
                />
            )}

            <ReferenceCards className={styles.cards} cards={cards} />

            {actions}
        </div>
    );
}
